/**
 * Shown by the exam guards when `GET /api/exam/current` timed out or failed for a student who
 * started an exam in this browser. Fail closed: the guarded page (practice, the archive's
 * solutions) stays hidden until the server answers, but there is a way to try again instead of a
 * spinner. Focus moves to the heading; only the message is announced (`role="alert"`).
 */
import { useEffect, useRef } from "react";
import { useT } from "@client/i18n";
import { useExamMode } from "./examMode";

export function ExamCheckFailed() {
  const t = useT();
  const { retryExamCheck } = useExamMode();
  const heading = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    heading.current?.focus();
  }, []);
  return (
    <div className="mx-auto max-w-2xl">
      <div className="flex flex-col items-center gap-3 rounded-xl border border-dashed border-ink-300 px-6 py-12 text-center dark:border-ink-700">
        <div role="alert" className="flex flex-col items-center gap-3">
          <h2
            ref={heading}
            tabIndex={-1}
            className="font-display text-lg text-ink-800 outline-none dark:text-ink-100"
          >
            {t("examGuard.checkFailed.title")}
          </h2>
          <p className="max-w-prose text-sm text-ink-600 dark:text-ink-400">
            {t("examGuard.checkFailed.body")}
          </p>
        </div>
        <button
          type="button"
          onClick={retryExamCheck}
          className="text-sm font-medium underline underline-offset-2"
        >
          {t("common.retry")}
        </button>
      </div>
    </div>
  );
}
